module.exports = __webpack_public_path__ + "img/testimonials.f2056d96.jpg";